import { OVERLAY_COLOR_OPAQUE } from '../../../theme/colors';
import { FTV_TIMING_FUNCTION_IN, MODAL_LAYER } from '../../../theme/constants';

export const MODAL_CONTAINER_STYLES = {
  default: {
    lineHeight: '21px',
    fontSize: 16,
    right: '16px',
    width: '480px',
    top: '12px',
    padding: 0,
    maxHeight: '100%',
    // we need to set height so scrollable will works fine because child is set to height: 100%
    // TODO: We need to refactore all the modal concept to avoid this tricks
    height: 'auto',
    maxWidth: 500,
    borderRadius: 20,
    position: 'absolute',
    marginRight: 'initial',
    transition: `all .25s ${FTV_TIMING_FUNCTION_IN}`,
    zIndex: MODAL_LAYER,
    pointerEvents: 'auto',
    background: OVERLAY_COLOR_OPAQUE,
    transitionProperty: 'max-width, width, opacity',
    transitionDuration: '.25s',
    transitionTimingFunction: FTV_TIMING_FUNCTION_IN
  },
  'extraSmall+small': {
    width: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
    lineHeight: '17px',
    right: 0,
    top: 0,
    borderRadius: 0
  },
  medium: { fontSize: 14 },
  large: { fontSize: 18 }
};
